import { Link } from 'react-router-dom';
import { logo_white } from '../../imports.js';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="footer-logo">
                <Link to='/'>
                    <img src={logo_white} alt="logo" />
                </Link>
                <p className='footer-outro'>Bringing back that new car feeling</p>
            </div>
           <div className='footer-links'>
                <a href="/memberships">Memberships</a>
                <a href="/giftcards">Gift Cards</a>
                <a href="/services">Services</a>
                <a href="/contact">Contact</a>
            </div>
            <div className="footer-social-media">
                <a href="https://www.facebook.com/"><i className="fab fa-facebook"></i></a>
                <a href="https://www.instagram.com/"><i className="fab fa-instagram"></i></a>
                <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a>
            </div>
            <hr />
            {/* <br /> */}
            <div className="footer-text-container">
                <p className='footer-text'>© 2025 All rights reserved || Premium Mobile Car Detailing || Designed by <span><a href='https://www.elkanamunganga.com' target='_blank' rel="noreferrer">Elkana Munganga</a></span></p>
            </div>
        </footer>
    );
};
export default Footer;